import { getCustomerRuleList } from '../services';
export const fetchRuleList = () => getCustomerRuleList().then(response => formatRule(response?.data));
const formatRule = (response) => {
    const result = response?.data?.map(item => ({
        name: item?.name || '-',
        createdAt: item?.createdAt,
        mainRule: item?.mainRule,
        id: item?.id,
    }));
    return result;
};
